import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { AssessmentReport } from 'types';
import clsx from 'clsx';
import AssessmentScore from 'components/common/AssessmentScore';

const useStyles = makeStyles((theme: Theme) => {
  return {
    dFlex: {
      display: 'flex',
    },
    pb4: {
      paddingBottom: theme.spacing(4),
    },
    mainContainer: {
      paddingLeft: theme.spacing(30),
      paddingRight: theme.spacing(30),
      paddingBottom: theme.spacing(10),
      display: 'flex',
      flexDirection: 'column',
    },
    pageHeader: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(2),
      alignItems: 'flex-end',
    },
    section: {
      backgroundColor: 'white',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(8),
      padding: theme.spacing(4),
      border: `1px solid ${(theme.palette as any).grey[600]}`,
      '& .MuiGrid-grid-xs-8': {
        display: 'flex',
        flexDirection: 'column',
        paddingRight: theme.spacing(4),
        '& form': {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
    sectionHeader: {
      color: theme.palette.primary.main,
    },
    btnFilled: {
      borderRadius: '100px',
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(4),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(4),
      lineHeight: '1rem',
    },
    vertTab: {
      height: '100%',
      margin: '0',
      borderLeft: `3px solid ${(theme.palette as any).grey[400]}`,

      '&>li': {
        paddingLeft: theme.spacing(4),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        marginLeft: '-3px',
        borderLeft: '3px solid transparent',
        cursor: 'pointer',

        '&>a': {
          color: theme.palette.black.main,
          textDecoration: 'none',
        },
      },
    },
    formSection: {
      marginTop: theme.spacing(4),
    },
    footerGroup: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    loading: {
      opacity: 0.4,
    },
    centered: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginRight: '-50%',
    },
    highlighted: {
      color: '#DC20AD',
    },
    ul: {
      listStyle: 'none',
      padding: 0,
    },
    pt1: {
      paddingTop: theme.spacing(1),
    },
  };
});

const DomainSelectionList = (props: {
  domains: any[];
  selectedIndex: number;
  assessmentReport?: AssessmentReport;
  activeSubStep?: number;
  callbackFn: (index: number) => void;
}) => {
  const classes = useStyles();
  function getStepContent(step) {
    if (step === 0) {
      return;
    }
    const maxSubSteps = props.domains[step].steps;
    return `${props.activeSubStep! + 1} of ${maxSubSteps}`;
  }
  return (
    <ul className={clsx(classes.ul, classes.vertTab)}>
      {props.domains.map((domain, index) => (
        <li key={index}>
          <Link onClick={() => props.callbackFn(index)}>
            <Grid container item xs={12}>
              <Grid item xs={8}>
                <Typography
                  variant="h4"
                  className={index === props.selectedIndex ? classes.highlighted : ''}
                >
                  {domain.title}
                </Typography>
                {index === props.selectedIndex &&
                  props.activeSubStep !== undefined &&
                  props.activeSubStep > -1 && (
                    <Typography className={classes.pt1}>{getStepContent(index)}</Typography>
                  )}
              </Grid>
              <Grid item xs={4}>
                {domain.id > 0 &&
                  props?.assessmentReport?.reportDomains?.find(
                    (stat) => stat.domainId === domain.id && stat.stats?.at(0)?.score
                  ) && (
                    <AssessmentScore
                      score={
                        props.assessmentReport.reportDomains
                          ?.find((stat) => stat.domainId === domain.id)
                          ?.stats?.at(0)?.score
                      }
                      showLabel={true}
                    />
                  )}
              </Grid>
            </Grid>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default DomainSelectionList;
